import { createSlice } from "@reduxjs/toolkit";
import {
  get_audio_assessment_question,
  save_audio_assessment_question,
  update_audio_assessment_question,
  delete_audio_assessment_question,
} from "./AudioAssessment.Thunk";

const initialState = {
  data: [],
  question: [],
  loading: false,
  status: "",
  message: "",
  program: "",
  clas: "",
  level: "",
  subject: "",
  questionId: "",
  selectedQuestion: null,
  // questions: null,
};

const AudioAssessmentSlice = createSlice({
  name: "audioassessmentslice",
  initialState,
  reducers: {
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.data = [];
    },
    program_change: (state, action) => {
      state.program = action.payload;
      state.data = [];
    },
    clas_change: (state, action) => {
      state.clas = action.payload;
      state.data = [];
    },
    level_change: (state, action) => {
      state.level = action.payload;
      state.data = [];
    },
    subject_change: (state, action) => {
      state.subject = action.payload;
      state.data = [];
    },
    question_change: (state, action) => {
      state.questionId = action.payload.questionId;
      state.question = action.payload.question;
      state.data = [];
    },
    setSelectedQuestion: (state, action) => {
      console.log(state, "state of the redux");
      state.selectedQuestion = action.payload;
      state.data = [];
    },
  },
  extraReducers: {
    [get_audio_assessment_question.pending]: (state, action) => {
      state.question = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [get_audio_assessment_question.fulfilled]: (state, action) => {
      state.question = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [get_audio_assessment_question.rejected]: (state, action) => {
      state.question = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [save_audio_assessment_question.pending]: (state, action) => {
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [save_audio_assessment_question.fulfilled]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [save_audio_assessment_question.rejected]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [update_audio_assessment_question.pending]: (state, action) => {
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [update_audio_assessment_question.fulfilled]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [update_audio_assessment_question.rejected]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [delete_audio_assessment_question.pending]: (state, action) => {
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [delete_audio_assessment_question.fulfilled]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [delete_audio_assessment_question.rejected]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const {
  usertype_change,
  program_change,
  clas_change,
  level_change,
  subject_change,
  question_change,
  setSelectedQuestion,
} = AudioAssessmentSlice.actions;

export default AudioAssessmentSlice.reducer;
